import { render, staticRenderFns } from "./standardOrderAppraise.vue?vue&type=template&id=33df9995&scoped=true"
import script from "./standardOrderAppraise.vue?vue&type=script&lang=js"
export * from "./standardOrderAppraise.vue?vue&type=script&lang=js"
import style0 from "./standardOrderAppraise.vue?vue&type=style&index=0&id=33df9995&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33df9995",
  null
  
)

export default component.exports